import { fields as simulationFields } from "../../../Simulation/fields"
import { fields as softleadFields } from "../../../Softlead/fields"

export const fields = {
  ...softleadFields,
  ...simulationFields
}
